import { apiClient } from './api';
import {
  StartInteractiveFictionSessionRequest,
  InteractiveFictionSessionStartResponse,
  CreateBranchPassageRequest,
  OptimizeEngagementRequest,
  AddGameMechanicsRequest,
  InteractiveFictionPassageResponse,
  InteractiveFictionSessionStatusResponse,
  InteractiveFictionVisualizationResponse
} from '../models/interactiveFiction';

export class InteractiveFictionService {
  static async startSession(request: StartInteractiveFictionSessionRequest): Promise<InteractiveFictionSessionStartResponse> {
    const response = await apiClient.post('/api/interactive-fiction/session/start', request);
    return response.data;
  }

  static async createOpeningPassage(sessionId: string): Promise<InteractiveFictionPassageResponse> {
    const response = await apiClient.post(`/api/interactive-fiction/session/${sessionId}/create-opening-passage`);
    return response.data;
  }

  static async createBranch(sessionId: string, request: CreateBranchPassageRequest): Promise<InteractiveFictionPassageResponse> {
    const response = await apiClient.post(`/api/interactive-fiction/session/${sessionId}/create-branch`, request);
    return response.data;
  }

  static async optimizeEngagement(sessionId: string, request: OptimizeEngagementRequest): Promise<InteractiveFictionPassageResponse> {
    const response = await apiClient.post(`/api/interactive-fiction/session/${sessionId}/optimize-engagement`, request);
    return response.data;
  }

  static async addGameMechanics(sessionId: string, request: AddGameMechanicsRequest): Promise<InteractiveFictionPassageResponse> {
    const response = await apiClient.post(`/api/interactive-fiction/session/${sessionId}/add-mechanics`, request);
    return response.data;
  }

  static async getSessionStatus(sessionId: string): Promise<InteractiveFictionSessionStatusResponse> {
    const response = await apiClient.get(`/api/interactive-fiction/session/${sessionId}`);
    return response.data;
  }

  static async getVisualization(sessionId: string): Promise<InteractiveFictionVisualizationResponse> {
    const response = await apiClient.get(`/api/interactive-fiction/session/${sessionId}/visualization`);
    return response.data;
  }
}

export default InteractiveFictionService;